import { Routes } from '@angular/router';

import { HomeLoggedMainComponent } from './home-logged-main/home-logged-main.component';
import { HomeLoggedShellComponent } from './home-logged-shell/home-logged-shell.component';
import { HomeLoggedCoursesComponent } from './screens/courses/courses.component';

export const routes: Routes = [
    {
        path: '',
        component: HomeLoggedShellComponent,
        // canActivate: [AuthGuard],
        children: [
            {
                path: '',
                component: HomeLoggedMainComponent,
            },
            {
                path: 'trader',
                component: HomeLoggedMainComponent
            },
            {
                path: 'cursos',
                component: HomeLoggedCoursesComponent
            },
        ]
    },
];
